import script from "./sw-item-editor-password.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-password.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-password.vue?vue&type=style&index=0&id=96118356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96118356"]])

export default __exports__